import moment from 'moment'
import React from 'react'

const CalendarDayOfWeekHeading = ({ date }) => {
  return (
    <div className='calendar-day-of-week-heading'>
      {moment(date).format('ddd')}
    </div>
  )
}

export default CalendarDayOfWeekHeading
